import React from 'react';

import EntryIcon from 'components/FileViewer/EntryIcon';
import ExplorerIcon from 'components/FileViewer/ExplorerIcon';
import {
  EntryActions, RowAction, entryLocation, entryModified, entrySizeText,
} from 'components/FileViewer/EntryTable';
import { ExplorerNode, formatModified } from 'helper/products/fileExplorer';

import './index.scss';

/** Lista mobile: linhas tocáveis (alvo de 44 px), sem seleção múltipla. */
export default function EntryList({
  entries,
  showPath,
  ...actions
}: EntryActions & {
  entries: ExplorerNode[];
  showPath: boolean;
}) {
  return (
    <ul className="file-explorer-list" aria-label="Conteúdo da pasta">
      {entries.map((node) => {
        const meta = `${entrySizeText(node)} · ${formatModified(entryModified(node))}`;
        const open = () => (node.kind === 'folder' ? actions.onOpenFolder(node.path) : actions.onDownload(node));
        return (
          <li key={node.key} className={`file-explorer-list-item is-${node.kind}`}>
            <button type="button" className="file-explorer-list-main" onClick={open}>
              <EntryIcon node={node} size="lg" />
              <span className="file-explorer-list-text">
                <span className="file-explorer-entry-name">{node.name}</span>
                {showPath && <span className="file-explorer-entry-path">{entryLocation(node)}</span>}
                <span className="file-explorer-list-meta">{meta}</span>
              </span>
              {node.kind === 'folder' && (
                <ExplorerIcon name="chevronRight" size={16} strokeWidth={2.4} className="file-explorer-list-chevron" />
              )}
            </button>
            {node.kind === 'file' && <RowAction node={node} actions={actions} size="lg" />}
          </li>
        );
      })}
    </ul>
  );
}
